




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Record } from '@/domains/work';
import { exportRecordTemplatePdfApi } from '@/api/work/RecordApi';
import { Load } from '@/domains/system';

@Component
export default class RecordPdfButton extends Vue {
  /** 记录 */
  @Prop()
  private value: Record;

  /** 获取记录 */
  get record(): Record { return this.value; }

  /** 设置记录 */
  set record(value: Record) { this.$emit('input', value); }

  private click() {
    Load.startFullLoad('正在导出PDF，请稍等。');
    exportRecordTemplatePdfApi(this.record.id).then((result: any) => {
      Load.stopFullLoad();
      window.open(result);
    }).catch(() => {
      Load.stopFullLoad();
    });
  }
}
